// Aquest arxiu configura la URL de l'API segons l'entorn (desenvolupament o producció)

const API_URL = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000';

export default API_URL;

// deploy trigger